var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-ver": _vm.$root.content.version } }, [
    _c(
      "div",
      { staticClass: "wrapper__parts" },
      _vm._l(_vm.$root.content.parts, function(part, i) {
        return _c(
          "a",
          {
            key: "part-" + i,
            class: {
              wrapper__link: true
            },
            attrs: {
              href: part.link,
              "data-tgev": "event10",
              "data-tgev-metric": "ev",
              "data-tgev-site": "newscomau",
              "data-tgev-section": "news",
              "data-tgev-container": "from-the-newsroom",
              "data-tgev-label": "" + part.title,
              "data-tgev-order": "" + (i + 1),
              "data-tgev-content-type": "story",
              "data-tgev-pagename": "from the newsroom podcast"
            },
            on: {
              mouseover: function($event) {
                _vm.mouseoverLink(part.type)
              },
              mouseout: _vm.mouseoutLink
            }
          },
          [_c("img", { attrs: { src: part.icon, alt: part.title } })]
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f7b704e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f7b704e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/link-block.vue
// module id = null
// module chunks = 